export default __webpack_public_path__ + "static/media/1.360e55fd.png";